import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { deleteCustomer, getAllCustomers, getCustomer, getCustomersApi } from '@/apis/customers'
import useNotification from '@/hooks/useNotification'
import { Customer } from '@/types'
import { GetAllCustomersRequest } from '@/types/apis/customers/GetAllCustomersRequest'
import { GetAllCustomersResponse } from '@/types/apis/customers/GetAllCustomersResponse'
import { GetCustomerResponse } from '@/types/apis/customers/GetCustomerResponse'
import { DeleteIdCardRequest } from '@/types/apis/idCards'

export const useCustomers = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [getCustomersLoading, setGetCustomersLoading] = useState(false)
  const [getCustomersResponse, setCustomersResponse] = useState<GetAllCustomersResponse>()
  const [customers, setCustomers] = useState<Customer[]>()
  const [customer, setCustomer] = useState<GetCustomerResponse>()
  const [deleteCustomerLoading, setDeleteCustomerLoading] = useState(false)

  const get = useCallback(async (request?: GetAllCustomersRequest) => {
    try {
      setGetCustomersLoading(true)
      const res = await getAllCustomers(request)

      setCustomersResponse(res)
    } finally {
      setGetCustomersLoading(false)
    }
  }, [])

  const getAllCustomer = useCallback(async () => {
    try {
      setGetCustomersLoading(true)
      const res = await getCustomersApi()

      setCustomers(res)
    } finally {
      setGetCustomersLoading(false)
    }
  }, [])

  const getCustomerDetail = useCallback(async (id: number) => {
    try {
      setGetCustomersLoading(true)
      const res = await getCustomer({ id })

      setCustomer(res)
    } finally {
      setGetCustomersLoading(false)
    }
  }, [])

  const del = useCallback(
    async ({ id }: DeleteIdCardRequest) => {
      try {
        setDeleteCustomerLoading(true)
        await deleteCustomer({ id })

        if (getCustomersResponse) {
          const newCustomers = getCustomersResponse.items.filter((item) => item.id !== id)
          setCustomersResponse({ ...getCustomersResponse, ...newCustomers })
        }
        openNotification({ type: 'success', description: t('components.pages.admins.common.delete.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.delete.fail') })
      } finally {
        setDeleteCustomerLoading(false)
      }
    },
    [getCustomersResponse, openNotification, t]
  )

  return {
    getCustomers: get,
    getCustomersResponse,
    getCustomersLoading,
    deleteCustomer: del,
    deleteCustomerLoading,
    getCustomerDetail,
    customer,
    getAllCustomer,
    customers,
  }
}
